import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import { Button, Card, Form, Input, message, Modal, Select } from 'antd'
// initCurryingObj
import { formatMessageNew, paginationInit } from '@/utils/common'
import { modalConfirm, modalError } from '@/utils/modalUtils'
import {
  addWriteOffNFCBatchNumber,
  addWriteOffNFCBatchNumberUpdate,
  changeWriteOffNFCBatchNumberStatus,
  findPlantModules,
  getWriteOffConfigBatchList
} from '@/services/writeOff/writeOff'
import { PlusOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import { hasPermission } from '@/annotations/nike-react'
import moment from 'moment'

const menu_nfc_configuration_writeOffNFCBatchNumber = 'menu_nfc_configuration_writeOffNFCBatchNumber'

const WriteOffNFCBatchNumber = () => {
  const [newModalForm] = Form.useForm()
  let editItemInfo = useRef({})
  let editItemFlag = useRef(false)
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [statusFlag, setStatusFlag] = useState(false)
  const [functionPlantOptions, setFunctionPlantOptions] = useState([])
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.writeOff.batchNumber'),
      dataIndex: 'batchNo'
    },
    {
      title: formatMessageNew('languageObj.writeOff.plant'),
      dataIndex: 'plant'
    },
    {
      title: formatMessageNew('languageObj.writeOff.planedQty'),
      dataIndex: 'plannedQty'
    },
    {
      title: formatMessageNew('languageObj.writeOff.writeOffStatus'),
      dataIndex: 'batchStatus'
    },
    {
      title: formatMessageNew('languageObj.writeOff.createTime'),
      dataIndex: 'createTime',
      render: text => text && moment(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: formatMessageNew('languageObj.writeOff.updateTime'),
      dataIndex: 'updateTime',
      render: text => text && moment(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: formatMessageNew('languageObj.commonLocale.operation'),
      dataIndex: 'operation',
      align: 'center',
      render: (text, record) => (
        <div>
          <Button
            disabled={!hasPermission(menu_nfc_configuration_writeOffNFCBatchNumber) || record.batchStatus !== 'Open'}
            type="link"
            size="small"
            onClick={() => {
              addAndEditRecord(record)
            }}
          >
            {formatMessageNew('languageObj.commonLocale.edit')}
          </Button>
        </div>
      )
    }
  ]

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    findPlantModulesFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const findPlantModulesFun = () => {
    let param = {
      isConfig: false
    }
    findPlantModules(param).then(res => {
      let ls = res.resultData.map(item => {
        return {
          label: item,
          value: item
        }
      })
      setFunctionPlantOptions(ls)
    })
  }
  useEffect(() => {
    if (selectedRowKeys.length <= 0 && statusFlag) setStatusFlag(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys])

  const searchDataFun = () => {
    const params = {
      pageNo: pagination.currentPage,
      size: pagination.pageSize,
      total: pagination.total
    }
    getWriteOffConfigBatchList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const changeStatus = () => {
    const params = {
      batchIds: selectedRowKeys,
      batchStatus: statusFlag ? 'Open' : 'Cancelled'
    }
    if (statusFlag) {
      requestChangeStatus(params)
      return
    }
    modalConfirm(
      {
        content: formatMessageNew('languageObj.writeOff.disableBatchNumberConfirmInfo'),
        onCancel: () => {}
      },
      () => requestChangeStatus(params)
    )
  }

  const requestChangeStatus = params => {
    changeWriteOffNFCBatchNumberStatus(params).then(res => {
      if (res.errorCode === '200') {
        message.success(formatMessageNew('languageObj.commonLocale.success'))
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      }
    })
  }

  const addBatchNumber = () => {
    newModalForm
      .validateFields()
      .then(values => {
        const { plant, batchNo, plannedQty } = values
        if (!plant || !batchNo) return
        // plannedQty 允许为 0 或空
        if (plannedQty !== undefined && isNaN(plannedQty)) {
          modalError({
            title: formatMessageNew('languageObj.writeOff.errTitlePlannedQty'),
            content: formatMessageNew('languageObj.writeOff.errMsgPlannedQty')
          })
          return
        }
        const params = { plant, batchNo, plannedQty }
        if (editItemFlag.current) {
          params.batchId = editItemInfo.current.id
          addWriteOffNFCBatchNumberUpdate(params)
            .then(res => {
              if (res.errorCode !== '200') return
              message.success(formatMessageNew('languageObj.commonLocale.success'))
              setQueryFlag(!queryFlag)
              setVisibleFlag(false)
            })
            .catch(err => {
              modalErrorFun(err)
            })
        } else {
          addWriteOffNFCBatchNumber(params)
            .then(res => {
              if (res.errorCode !== '200') return
              message.success(formatMessageNew('languageObj.commonLocale.success'))
              setQueryFlag(!queryFlag)
              setVisibleFlag(false)
            })
            .catch(err => {
              modalErrorFun(err)
            })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const modalErrorFun = err => {
    let title = ''
    let msg = 'languageObj.httpLocale.requestError'
    if (err.errorCode === '2201') {
      title = 'languageObj.writeOff.errTitleBatchNumberExist'
      msg = 'languageObj.writeOff.errMsgBatchNumberExist'
    }
    modalError({
      title: formatMessageNew(title),
      content: formatMessageNew(msg)
    })
  }

  const hideAddModal = () => {
    newModalForm.resetFields()
    setVisibleFlag(false)
  }

  const addAndEditRecord = record => {
    setVisibleFlag(true)
    if (record) {
      let params = {
        ...record
      }
      editItemFlag.current = true
      editItemInfo.current = params
      newModalForm.setFieldsValue(params)
    } else {
      editItemFlag.current = false
      editItemInfo.current = {}
      newModalForm.resetFields()
    }
  }

  const onSelectChange = newSelectedRowKeys => {
    const matchedObjects = _.filter(tableList, obj => _.includes(newSelectedRowKeys, obj.id))
    let allFalse = _.every(matchedObjects, ['batchStatus', 'Cancelled'])
    setStatusFlag(allFalse)
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        {hasPermission(menu_nfc_configuration_writeOffNFCBatchNumber) && (
          <>
            <Button
              type="primary"
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={() => {
                addAndEditRecord()
              }}
            >
              <PlusOutlined />
              {formatMessageNew('languageObj.writeOff.addBatchNumber')}
            </Button>
            <Button
              type="primary"
              danger={!statusFlag}
              disabled={!hasSelected}
              style={{ marginLeft: '20px', marginTop: '10px' }}
              onClick={changeStatus}
            >
              {statusFlag
                ? formatMessageNew('languageObj.writeOff.reActive')
                : formatMessageNew('languageObj.writeOff.cancelBatchNumber')}
            </Button>
          </>
        )}
        <div className="content-container">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={
              hasPermission(menu_nfc_configuration_writeOffNFCBatchNumber)
                ? {
                    ...rowSelection,
                    getCheckboxProps: record => ({
                      disabled: !(record.batchStatus === 'Cancelled' || record.batchStatus === 'Open')
                    })
                  }
                : false
            }
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={
          editItemFlag.current
            ? formatMessageNew('languageObj.writeOff.editBatchNumber')
            : formatMessageNew('languageObj.writeOff.addBatchNumber')
        }
        onOk={addBatchNumber}
        onCancel={hideAddModal}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          style={{ maxWidth: 680 }}
          autoComplete="off"
        >
          <Form.Item
            label={formatMessageNew('languageObj.writeOff.plantCode')}
            name="plant"
            rules={[{ required: true }]}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              options={functionPlantOptions}
            ></Select>
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.writeOff.batchNumber')}
            name="batchNo"
            rules={[
              { required: true },
              {
                pattern: /^[^\\/:*?"<>|]+$/,
                message: formatMessageNew('languageObj.writeOff.spcWordMsg')
              }
            ]}
          >
            <Input allowClear placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.writeOff.planedQty')}
            name="plannedQty"
            initialValue={0}
            rules={[
              {
                pattern: /^(0|[1-9]\d*)$/,
                message: formatMessageNew('languageObj.writeOff.positiveInteger')
              }
            ]}
          >
            <Input allowClear placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default WriteOffNFCBatchNumber
